import { apiClient } from "../../../services/api";

export const stripeService = {
  async stripeSub(subscriptionId) {
    //: string
    return apiClient.request("/api/stripeSub", {
      body: { subscriptionId },
      method: "POST",
      requireAuth: true,
    });
  },

  async updateCustomer(params) {
    //: { email: string; value: any }
    return apiClient.request("/api/customer", {
      body: params,
      method: "PATCH",
      requireAuth: true,
    });
  },

  async getStripePaymentMethods(params) {
    //: { email: string }
    return apiClient.request("/api/stripePaymentMethods", {
      body: params,
      method: "POST",
    });
  },

  async stripeUpdateCard(params) {
    //:{ email: string; subscriptionId: string }
    return apiClient.request("/api/stripeUpdateCard", {
      body: params,
      method: "POST",
    });
  },

  async setStripePartnerSub(
    params
    //   : {
    //   addOn: boolean
    //   coupon: string
    //   email: string
    //   productId: SubscriptionT
    // }
  ) {
    return apiClient.request("/api/stripePartnerSub", {
      body: params,
      method: "POST",
    });
  },

  async setStripeSubscription(
    params
    //   : {
    //   email: string
    //   freeTrial: number
    //   productId: SubscriptionT
    //   addOn?: boolean
    //   coupon?: string
    // }
  ) {
    return apiClient.request("/api/stripeCreateSubscription", {
      body: params,
      method: "POST",
    });
  },

  async stripeCreateIntent(
    params
    // : { amount: number; email: string; paymentMethod?: string }
  ) {
    return apiClient.request("/api/stripeCreateIntent", {
      body: params,
      method: "POST",
    });
  },
};
